function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment/moment';
import { formatTimestamp } from 'helpers/datetime';
import messages from '../../../messages';
import StackDataList from '../StackDataList';
import styles from './RelatedData.pcss';
const MealTooltip = ({ element })=>{
    useStyles(styles);
    const nutrients = [
        'carbs',
        'protein',
        'energy',
        'fat'
    ];
    const getUnit = (type)=>{
        switch(type){
            case 'energy':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energyUnit));
            default:
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.nutrientUnit));
        }
    };
    const nutrientsLabel = {
        carbs: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.carbs)),
        protein: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.protein)),
        energy: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energy)),
        fat: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.fat))
    };
    const nutrientsData = nutrients.reduce((result, nutrient)=>{
        if (!element[nutrient]) {
            return result;
        }
        return [
            ...result,
            {
                label: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        nutrientsLabel[nutrient],
                        " (",
                        getUnit(nutrient),
                        ")"
                    ]
                }),
                value: element[nutrient]
            }
        ];
    }, []);
    const data = [
        {
            label: formatTimestamp(element.timestamp, 'DD/MM/YYYY'),
            value: /*#__PURE__*/ _jsx("span", {
                children: formatTimestamp(element.timestamp, 'HH:mm')
            })
        },
        {
            label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time)),
            value: moment.unix(element.timestamp).utc().format('LT')
        },
        ...nutrientsData
    ];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.tooltipTitle,
                children: [
                    element.isSnaqImport && /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/snaq.svg",
                        alt: "snaq.io",
                        className: styles.tooltipTitle__snaqIcon
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.tooltipTitle__titleText,
                        children: element.name
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StackDataList, {
                data: data
            })
        ]
    });
};
export default /*#__PURE__*/ memo(MealTooltip);
